import { Outlet } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import PopupAd from "@/components/PopupAd";
import { Toaster } from "@/components/ui/sonner";

export default function PublicLayout() {
  return (
    <div className="min-h-screen flex flex-col bg-[#FAF9F6] text-[#1A2421]">
      <Navbar />
      <main className="flex-1"><Outlet /></main>
      <Footer />
      <PopupAd />
      <Toaster position="top-right" richColors />
    </div>
  );
}
